import { Navigation } from "@/types";

export const defaultNavigation: Navigation = {
  main: [
    { name: "Contact Us", href: "/contact-us" },
    { name: "Refund Policy", href: "/refund-policy" },
    { name: "Terms and Conditions", href: "/terms-and-conditions" },
    { name: "Privacy Policy", href: "/privacy-policy" },
  ],
} as const;

export const HOUR_IN_MS = 60 * 60 * 1000;
export const RELOAD_DELAY_MS = 5000;
export const BACKEND_CHECK_INTERVAL_MS = 60000;
export const COUNTDOWN_INTERVAL_MS = 1000;